module.exports = __webpack_public_path__ + "static/media/1.0355eb54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/carousel/1.jpg
// module id = 658
// module chunks = 6